KMVP.creditcard = {
    sCreditCardOverlaySelector: "#js-credit-card-overlay",
    sRetryUrl: ""
};

KMVP.creditcard.$creditCardOverlay = $(KMVP.creditcard.sCreditCardOverlaySelector);
KMVP.creditcard.$registerForm = KMVP.creditcard.$creditCardOverlay.find(".js-cc-register-form");
KMVP.creditcard.$iframe = KMVP.creditcard.$registerForm.find("iframe");
KMVP.creditcard.$responseError = KMVP.creditcard.$creditCardOverlay.find(".js-cc-response-error");

KMVP.creditcard.toggleCreditCardOverlay = function(bShowRegisterForm){
    if(bShowRegisterForm){
        KMVP.creditcard.$registerForm.show();
        KMVP.creditcard.$responseError.hide();
    } else {
        KMVP.creditcard.$registerForm.hide();
        KMVP.creditcard.$responseError.show();
    }
    $.colorbox.resize();
};

KMVP.creditcard.loadIframe = function(sUrl){
    KMVP.creditcard.$iframe.attr("src", sUrl);
};

KMVP.creditcard.iframeOnLoad = function () {
    // hack: onload check whether iframe url is from same origin, because only then it is readable without exception
    try {
        this.contentWindow.location.href.length;
    }
    catch (e) {
        return;
    }
    // if the content contains #status, the registration is complete
    var $this = $(this);
    var $iframeContents = $this.contents();
    var $statusDiv = $iframeContents.find("#status");
    if ($statusDiv.length >= 1) {
        switch($statusDiv.text()) {
            case "ACCEPTED":
                // success, refresh page to show credit card
                if($this.closest(".page-singleStepCheckoutSummaryPage").length > 0) {
                    ACC.checkoutB2B.refresh();
                } else {
                    window.location.reload();
                }
                $.colorbox.close();
                break;
            case "CANCELED":
                $.colorbox.close();
                break;
            default: // ERROR code
                // error, present error message:
                var $message = $iframeContents.find("#message");
                KMVP.creditcard.$responseError.find(".js-error-message").text($message.length >= 1 ? $message.text() : "");
                // save retry url
                var $retryUrl = $iframeContents.find("#retryUrl");
                if($retryUrl.length >= 1) {
                    KMVP.creditcard.sRetryUrl = $retryUrl.text()
                }
                KMVP.creditcard.toggleCreditCardOverlay(false);
        }
    }
};

KMVP.creditcard.retry = function(){
    KMVP.creditcard.loadIframe(KMVP.creditcard.sRetryUrl);
    KMVP.creditcard.toggleCreditCardOverlay(true);
};

KMVP.creditcard.openRegisterPopup = function() {
    KMVP.creditcard.toggleCreditCardOverlay(true);
    // sHeidelpayRegistrationUrl is set in tag file taken from controller
    KMVP.creditcard.loadIframe(sHeidelpayRegistrationUrl);
    $.colorbox({
        inline: true,
        href: KMVP.creditcard.sCreditCardOverlaySelector,
        innerWidth: "750px",
        innerHeight: "550px"
    });
};

KMVP.creditcard.bindButtons = function() {
    KMVP.creditcard.$responseError.find(".js-cancel").on("click", $.colorbox.close);
    KMVP.creditcard.$responseError.find(".js-retry").on("click", KMVP.creditcard.retry);
    $(document).on("click", ".js-add-credit-card-button", KMVP.creditcard.openRegisterPopup);
};

$(document).ready(function () {
    KMVP.creditcard.bindButtons();
    KMVP.creditcard.$iframe.on("load", (KMVP.creditcard.iframeOnLoad));
});
